export interface ServiceUrls {
  activity?: string;
  featureFlags?: string;
}

export interface ServiceUrlEnv {
  DEV: boolean;
  VITE_ACTIVITY_API_URI?: string;
  VITE_FEATURE_FLAGS_API_URI?: string;
}

/**
 * On a local dev server the Activity and Feature Flags APIs default to a local
 * stack (ports 5050 and 5053) rather than the environment file's deployed
 * URLs. VITE_ACTIVITY_API_URI and VITE_FEATURE_FLAGS_API_URI override the
 * URL whenever they're set, on a dev server or in a build.
 * playwright.config.ts sets them so e2e's dev server reaches the dev APIs, and
 * an outage there fails the test instead of every call failing against a port
 * nothing listens on (#519).
 */
export function resolveServiceUrls(
  env: ServiceUrlEnv,
  configured: ServiceUrls,
): ServiceUrls {
  const localStackOr = (port: number, deployedUrl: string | undefined) =>
    env.DEV ? `http://localhost:${port}` : deployedUrl;

  return {
    activity:
      env.VITE_ACTIVITY_API_URI || localStackOr(5050, configured.activity),
    featureFlags:
      env.VITE_FEATURE_FLAGS_API_URI ||
      localStackOr(5053, configured.featureFlags),
  };
}
